export const AllMessageIndicator = 'MESSAGE_ALL'